import React, { Fragment, useState } from 'react';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { Link } from 'react-router-dom';
import ModalForChangePassword from '../Security/ModalForChangePassword';
import ModalForUpdateUser from '../User/ModalForUpdateUser';
import { StyledMenuItem } from '../../styles/styled/MenuItem.styled';
import { UserProfile } from '../../enums/HeaderEnums';
import { useDispatch } from 'react-redux';
import { changePassword, deleteErrorLogin } from '../../actions/security';

const MenuBarUserProfile = ({
  logout,
  loggedUser,
  user,
  showUpdateModal,
  showUpdateUserModal,
  setShowUpdateUserModal,
  handleEdit,
}) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const clearValidationErrors = () => {
    dispatch(deleteErrorLogin());
  };

  const showModal = () => {
    setShowChangePasswordModal(true);
  };

  const handleCloseModal = () => {
    setShowUpdateUserModal(false);
    setShowChangePasswordModal(false);
    clearValidationErrors();
  };

  const handleChangePassword = (changePasswordDTO) => {
    dispatch(changePassword(changePasswordDTO, handleCloseModal));  
  };

  return (
    <div>
      <div className="userProfileCircle" onClick={handleClick}>
        {loggedUser.initials}
      </div>
      <Menu
        id="userprofile"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <StyledMenuItem onClick={handleClose}>
          <ListItemIcon>
            <AccountCircleIcon fontSize="small" />
          </ListItemIcon>
          <Link
            to="#"
            id="updateUserProfile"
            onClick={() => {
              showUpdateModal();
            }}
          >
            <ListItemText primary={UserProfile.profile} />
          </Link>
        </StyledMenuItem>
        <StyledMenuItem onClick={handleClose}>
          <ListItemIcon>
            <VpnKeyIcon fontSize="small" />
          </ListItemIcon>
          <Link
            to="#"
            id="changePasswordUserProfile"
            onClick={() => {
              showModal();
            }}
          >
            <ListItemText primary={UserProfile.changePassword} />
          </Link>
        </StyledMenuItem>
        <StyledMenuItem onClick={handleClose}>
          <ListItemIcon>
            <ExitToAppRoundedIcon fontSize="small" />
          </ListItemIcon>
          <Link onClick={logout}>
            <ListItemText primary={UserProfile.logout} />
          </Link>
        </StyledMenuItem>
      </Menu>
      <Fragment>
        {showChangePasswordModal && (
          <ModalForChangePassword
            handleChangePassword={handleChangePassword}
            handleClose={handleCloseModal}
            showChangePasswordModal={showChangePasswordModal}
          />
        )}
        {showUpdateUserModal && (
          <ModalForUpdateUser
            show={showUpdateUserModal}
            user={user}
            handleClose={handleCloseModal}
            handleEdit={handleEdit}
          />
        )}
      </Fragment>
    </div>
  );
};

export default MenuBarUserProfile;
